<template>
  <header class="ignore-header-component">
    <div class="content-main">
      <img :src="logoImg" alt="" class="logo">
      <nav>
        <div class="nav-item" :class="{active: $route.name == 'home'}" @click="goRoute('home')">首页</div>
        <div class="nav-item" :class="{active: $route.name == 'news'}" @click="goRoute('news')" >新闻中心</div>
        <div class="nav-item" :class="{active: $route.name == 'aboutUs'}" @click="goRoute('aboutUs')">关于我们</div>
        <div class="search-wrapper">
          <img class="search-icon" :src="searchIcon" alt="">
          <input type="text" disabled>
          <div class="placeholder">搜好车</div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import logoImg from '../assets/home-logo.png';
import searchIcon from '../assets/search.png';

export default {
  data () {
    return {
      logoImg,
      searchIcon
    };
  },
  methods: {
    goRoute (routeName) {
      this.$router.push({ name: routeName });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/var.scss";
@import "../styles/mixin.scss";

.ignore-header-component {
  background-color: $main-color;
  font-size: 14px;

  .content-main {
    width: $content-width;
    margin: 0 auto;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .logo {
      width: 130px;
    }
  }

  nav {
    display: flex;
    align-items: center;

    .nav-item {
      cursor: pointer;
      min-width: 60px;
      padding: 0 10px;
      margin-left: 30px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      position: relative;
      z-index: 1;

      &.active {
        color: #fff;

        &::after {
          @include skew-bg;
          background-color: #000;
        }
      }
    }

    .search-wrapper {
      width: 110px;
      height: 25px;
      background-color: #fff;
      transform: $skew-deg;
      margin-left: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      padding-left: 10px;
      position: relative;

      .search-icon {
        width: 24px;
        height: 24px;
        transform: $skew-deg-reverse translate(-50%, -50%);
        display: block;
        position: absolute;
        left: 20%;
        top: 50%;
      }

      input {
        display: block;
        flex: auto;
        width: 100px;
        align-self: stretch;
        background-color: transparent;
        outline: none;
        border: none;
        transform: $skew-deg-reverse translate(-50%, -50%);
        text-align: center;
        font-size: 12px;
        z-index: 1;
        position: absolute;
        top: 50%;
        left: 50%;

        &:focus + .placeholder {
          display: none;
        }
      }

      .placeholder {
        color: #a6a6a6;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%) scale(0.8) $skew-deg-reverse;
        font-size: 12px;
      }
    }
  }
}
</style>
